import { type PropsWithChildren } from 'react'
import { cn } from '~/shadcn/lib/utils'

export function InfoCardWrapper({ children }: PropsWithChildren) {
  return (
    <div
      className={cn(
        'p-3 px-5',
        'bg-[#EBF4FF]',
        'border border-border',
        'rounded'
      )}>
      {children}
    </div>
  )
}
